import GivenLeads from "./GivenLeads";

import "./App.scss";

function App() {
  return <GivenLeads />;
}

export default App;
